import { render, staticRenderFns } from "./PurchaseHistory.vue?vue&type=template&id=00b7c628&scoped=true"
import script from "./PurchaseHistory.vue?vue&type=script&lang=js"
export * from "./PurchaseHistory.vue?vue&type=script&lang=js"
import style0 from "./PurchaseHistory.vue?vue&type=style&index=0&id=00b7c628&prod&lang=scss"
import style1 from "./PurchaseHistory.vue?vue&type=style&index=1&id=00b7c628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b7c628",
  null
  
)

export default component.exports